import { paths } from 'src/routes/paths';

const screens = {
  'My Interviews': paths.dashboard.talentAcquisition.ListInterview,
  'Schedule Interview': paths.dashboard.talentAcquisition.listAndCalendarView,
  'Selected Candidates': paths.dashboard.talentAcquisition.SelectedCandidates,
  'Candidate Requisition': paths.dashboard.talentAcquisition.CanReqTagList,
  'Offered Candidates': paths.dashboard.talentAcquisition.OfferedCandidates,
  'Cancel Candidate Requisition':
    paths.dashboard.ManagerApproval.CandidateRequisitionApproval.CancelCanReq,
  'Candidate Requisitions Approval':
    paths.dashboard.ManagerApproval.CandidateRequisitionApproval.CanReqApproval,
  'Material Requisitions Approvals': paths.dashboard.ManagerApproval.MaterialReqApproval,
  'Purchase Requisitions Approval': paths.dashboard.ManagerApproval.PurReqApproval,
  'Inventory Transactions': paths.dashboard.product.InvTransaction,
  'Material Inspection': paths.dashboard.inventory.InspectionList,
  'Master': paths.dashboard.masters.globalMasters.ActionTables,
};

export default screens;
